module.exports = __webpack_public_path__ + "static/media/warning.b2d43408.svg";